/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_For_YouInputs */

const en_wc_dl_for_you = /** @type {(inputs: Wc_Dl_For_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended for your system`)
};

/**
* | output |
* | --- |
* | "Recommended for your system" |
*
* @param {Wc_Dl_For_YouInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_for_you = /** @type {((inputs?: Wc_Dl_For_YouInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_For_YouInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_for_you(inputs)
});
export { wc_dl_for_you as "wc.dl.for_you" }